import axios from 'axios';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import store from '@/store';
import detector from "@/utils/mobileDetector";

const DELAY_AUTOPLAY_FIRST = 500;
const DELAY_AUTOPLAY = 1800;

const apiEndpoint = sunstudyId => (
  process.env.NODE_ENV === 'production'
    ? apiEndpointConst(sunstudyId, 'sunstudy', '')
    : `/api-proxy/sunstudy/${sunstudyId}`
);

export default {
  load,
  startSunstudyAutoplay,
  stopSunstudyAutoplay,
  toggleSunstudyAutoplay,
  setSunstudyPosition,
  toggleSunstudyMode,
  setPosition,
  setSeasonPosition,
  resetSunstudyMode,
  stopSunstudyMode,
  setActivationButtonSunstudy,
};

function load({ commit, state }, identifiers) {
  return [].concat(identifiers)
    .reduce((chain, id) => chain.then(() => {
      const sunstudy = state.seasons.find(season => season.id === id);

      return sunstudy
        ? Promise.resolve(sunstudy)
        : axios.get(apiEndpoint(id), { headers: authHeader })
          .then(res => commit('add', Object.assign(res.data.data, { id })));
    }), Promise.resolve());
}

function startSunstudyAutoplay({ commit, dispatch, state }) {
  // make quicker the first iteration of autoplay
  iterate(state.autoplayTimeout === undefined
    ? DELAY_AUTOPLAY
    : DELAY_AUTOPLAY_FIRST);

  // ////////////////////////
  function iterate(delay = DELAY_AUTOPLAY) {
    commit('setAutoplay', setTimeout(
      () => {
        dispatch('setPosition', state.position + 1);
        iterate();
      },
      delay,
    ));
  }
}

function stopSunstudyAutoplay({ commit, state }, manual) {
  if (state.autoplayTimeout) {
    clearTimeout(state.autoplayTimeout);
    commit('setAutoplay', manual ? null : undefined);
  }
}

function toggleSunstudyAutoplay({ dispatch, state }) {
  return state.autoplayTimeout
    ? dispatch('stopSunstudyAutoplay', true)
    : dispatch('startSunstudyAutoplay', true);
}
function stopSunstudyMode({ commit }) {
  commit('setSunstudyMode', false);
  commit('setPosition', 0);
  commit('setSeason', 0);
  setBackDefaultExteriorOverlayStatus()
}

function setActivationButtonSunstudy({ commit }, value) {
  commit('setActivationButtonSunstudy', value);
}

function setSunstudyPosition({ dispatch }, position) {
  dispatch('setPosition', position);

  return dispatch('stopSunstudyAutoplay');
}

function toggleSunstudyMode({ commit, state, dispatch, getters }) {
  commit('setSunstudyMode', !state.showing);

  if (state.showing) {
    store.dispatch('exteriors/toggleShowOverlayStatus', false)
    if (window.innerWidth < 768) {
      store.dispatch('service/hideMiniMap')
    }

    if (state.autoplayTimeout === undefined && !getters.sunstudy.default) {
      dispatch('startSunstudyAutoplay');
    }
  } else {
    setBackDefaultExteriorOverlayStatus()
    dispatch('stopSunstudyAutoplay');
  }
}

function setBackDefaultExteriorOverlayStatus() {
  if (detector.mobile()
    ? !store.getters['project/statusSwitchMobileOff']
    : store.getters['project/statusSwitch'] === 1) {
    store.dispatch('exteriors/toggleShowOverlayStatus', true)
  }
}

function setPosition({
  state, getters, commit, dispatch,
}, value) {
  const position = Math.floor(value);

  if (position < getters.sunstudy.images.length && position >= 0) {
    commit('setPosition', position);
  } else {
    commit('setPosition', 0);
    dispatch('setSeasonPosition', state.seasonPosition + 1);
  }
}

function setSeasonPosition({ state, getters, commit }, value) {
  if (state.seasonPosition !== value) {
    commit(
      'setSeason',
      value < getters.sunstudySeasons.length && value >= 0 ? value : 0,
    );
  }
}

function resetSunstudyMode({ commit, dispatch, state }, data) {
  const EXTERIOR_ROUTE = 'order.overview.exterior';
  const { name } = data.to;
  const from = +data.from.params.exteriorId;
  const to = +data.to.params.exteriorId;

  if (from !== to) {
    if (state.showing) {
      commit('setSunstudyMode', false);
    }

    if (state.position !== 0) {
      commit('setPosition', 0);
    }

    if (state.seasonPosition !== 0) {
      commit('setSeason', 0);
    }

    if (state.autoplayTimeout) {
      return dispatch('stopSunstudyAutoplay');
    }
  } else if (state.showing) {
    if (name !== EXTERIOR_ROUTE) {
      if (state.autoplayTimeout) {
        return dispatch('stopSunstudyAutoplay');
      }
    } else if (state.autoplayTimeout === undefined) {
      return dispatch('startSunstudyAutoplay');
    }
  }

  return Promise.resolve();
}
